import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/sousuo.png';

const _withScopeId = n => (_pushScopeId("data-v-30bc7080"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};
const _hoisted_2 = {
  class: "owin-height"
};
const _hoisted_3 = {
  class: "notice-top"
};
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("共");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("本教材");

const _hoisted_7 = {
  class: "search-box"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "search-icon",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_9 = {
  class: "notice-wrapper"
};
const _hoisted_10 = {
  class: "notice-list-wrapper"
};
const _hoisted_11 = {
  key: 0,
  class: "notice-list"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "second-left"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "second-right"
};
const _hoisted_16 = {
  class: "right-title"
};
const _hoisted_17 = {
  class: "right-teacher"
};
const _hoisted_18 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_CommonTopTitle = _resolveComponent("CommonTopTitle");

  const _component_el_input = _resolveComponent("el-input");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event)
  }, null, 8, ["menuInfo"]), _createVNode(_component_CommonTopTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.menuName), 1)]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString($data.pageInfo.rows), 1), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
    modelValue: $data.newsName,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.newsName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _cache[2] || (_cache[2] = _withKeys($event => $options.handleSearch(), ["enter"])),
    placeholder: "搜索教材名称"
  }, null, 8, ["modelValue"]), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "second-style",
      key: item.id,
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: item.cover || require('@/assets/images/video-cover.png'),
      alt: ""
    }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_17, "主编：" + _toDisplayString(item.chief_editor), 1)])], 8, _hoisted_12);
  }), 128))])) : _createCommentVNode("", true), !$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])) : _createCommentVNode("", true), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "news-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])])]), _createVNode(_component_Footer)]);
}